<div
  class="c-startNow"
  theming
  themingGroup="none"
  themingAsset="start-now-shine">
  <div class="c-startNow__game">
    <div
      class="c-startNow__gameIcon"
      [ngStyle]="gameIcon"
      avoidMulticlick
      (safeClick)="closeModal()"></div>
    <div class="c-startNow__gameGlow"></div>
    <div
      class="c-startNow__signboard"
      #signboard
      theming
      themingGroup="none"
      themingAsset="start-now-sign"></div>
  </div>

  <div class="c-startNow__dialog">
    <div
      class="c-startNow__juliet"
      #juliet>
      <slotcom-juliet-buddy
        [location]="'start-now'"
        [pose]="startNowModalPose"
        [hasDim]="true"></slotcom-juliet-buddy>
    </div>
  </div>
</div>
